/** Query keys for the email schedules table. */
export const emailScheduleKeys = {
  all: ["email-schedules"],
  lists: () => [...emailScheduleKeys.all, "list"],
  list: ({ campaignId = null } = {}) => [
    ...emailScheduleKeys.lists(),
    { campaignId },
  ],
};
